import { useEffect } from 'react';

/**
 * Unsaved form + reload or close tab → the browser's own "Leave site?"
 * prompt. In-app links are covered by useLeaveGuard.
 */
export const useBeforeUnload = (active: boolean) => {
  useEffect(() => {
    if (!active) return undefined;
    const handler = (ev: BeforeUnloadEvent) => {
      ev.preventDefault();
      // eslint-disable-next-line no-param-reassign
      ev.returnValue = '';
    };
    window.addEventListener('beforeunload', handler);
    return () => window.removeEventListener('beforeunload', handler);
  }, [active]);
};
